import React from "react";
import styled from "styled-components";
import healthShield from "../../../health-shield.svg";

export function HealthShield() {
  return (
    <ShieldContainer>
      <Shield src={healthShield} alt="" role="presentation" />
    </ShieldContainer>
  );
}

const ShieldContainer = styled.div`
  margin-top: -${(props) => props.theme.spacing.lg};
  margin-left: -${(props) => props.theme.spacing.lg};
  margin-right: -${(props) => props.theme.spacing.lg};
  margin-bottom: ${(props) => props.theme.spacing.lg};
  background-color: ${(props) => props.theme.color.backgroundAlternate};
  padding-bottom: ${(props) => props.theme.spacing.xl};
  padding-top: ${(props) => props.theme.spacing.xl};
  /* spacing.lg in calc below comes from margin-left and margin-right above */
  width: calc(
    100% + 2 * ${(props) => props.theme.spacing.lg}
  );
  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 0;
    padding-top: 0;
    flex-basis: 360px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: ${(props) => props.theme.spacing.xl};
  }
`;

const Shield = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;

  width: 60px;
  height: 60px;
  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    width: 192px;
    height: 192px;
  }
`;
